import { Style } from "@portal/lib/style/style";

export const FilterDropdownWrapper = Style("div", {
  ".ant-dropdown-menu": {
    maxHeight: "350px",
    overflowY: "auto",
  },
});
